import TagManager from 'react-gtm-module'
import {GTM_ID} from "./api";

const tagManagerArgs = {
    gtmId: GTM_ID
}
TagManager.initialize(tagManagerArgs)